// Port of api/fuel/app/classes/filter/search/games/filters/query/pseudo.php
import F from 'offline/filter/constants'
export default {
	name: 'pseudo',
	priority: 90,
	require: function(config) {
		return config.pseudoType !== F.PSEUDO_GAME
	},
	run: function(config, filter, data, query) {
		if (config.pseudoType === F.PSEUDO_RATING) {
			query.select('COUNT(r.rating_id)', 'pseudo')
		} else if (config.pseudoType === F.PSEUDO_PLAY) {
			if (filter.play && filter.play.group) {
				query.select('COUNT(DISTINCT(p.game_id))', 'pseudo')
			} else {
				query.select('SUM(p.play_count)', 'pseudo')
			}
		} else if (config.pseudoType === F.PSEUDO_COLLECTION) {
			query.select('COUNT(DISTINCT(c.collection_id))', 'pseudo')
		}
	}
}
